<!-- container-xxl  -->
<div class="content-wrapper p-0">
	<div class="content-body">
		<!-- content-header component -->
		<app-content-header [contentHeader]="contentHeader"></app-content-header>

		<!-- account setting page -->
		<section id="page-account-settings">
			<div class="row nav-vertical d-flex">
				<div class="col-md-3 mb-2 mb-md-0">
					<ul ngbNav #navVertical="ngbNav" class="nav nav-pills flex-column nav-left">
						<li class="nav-item" ngbNavItem>
							<a ngbNavLink class="nav-link d-flex py-75" id="account-pill-general" data-toggle="pill"
								href="#account-vertical-general" aria-expanded="true">
								<i data-feather="user" class="font-medium-3 mr-1"></i>
								<span class="font-weight-bold">General</span>
							</a>
							<ng-template ngbNavContent>
								<!-- <div class="card"> -->
									<!-- <div class="card-body"> -->
										<form [formGroup]="updateProfileform" autocomplete="off">
											<!-- <div class="media">
												<a href="javascript:void(0);" class="mr-25">
													<span class="avatar"><img class="round" src="{{avatarImage}}" alt="{{avatarImage}}" height="80" width="80" /><span class="avatar-status"></span></span>
												</a>
												upload button
												<div class="media-body mt-75 ml-1">
													<div class="file-field row">
														<div class="col-md-4">
															<label class="form-label" for="uploadProfile">Upload Profile</label>
															<div class="custom-file">
																<input type="file" [uploader]="uploader" class="custom-file-input" ng2FileSelect id="file-upload-single"
																	(click)="browsbuttonClick('uploadProfile')" (change)="onFileChange($event, 'uploadProfile')"/>
																<label class="custom-file-label" id="uploadProfile"
																	for="file-upload-single">{{profileData.profilePhoto.value}}</label>
															</div>
														</div>
													</div>
													<div class="row">
														<p>Allowed JPG, GIF or PNG. Max size of 800kB</p>
													</div>
												</div>
											</div> -->
											<fieldset class="border" style="padding: 0.7rem;">
												<legend class="w-auto">
													<h5 style="margin-top: 7px;"></h5>
												</legend>
												<div class="row">
													<div class="form-group col-md-4">
														<label class="form-label" for="userName">Name</label>
														<input formControlName="userName" type="text"
															name="userName" id="userName" class="form-control"
															placeholder="User Name" readonly/>
													</div>
													<div class="form-group col-md-4">
														<label class="form-label" for="userEmail">Email</label>
														<input formControlName="userEmail" type="text"
															name="userEmail" id="userEmail" class="form-control"
															placeholder="User Email" readonly/>
													</div>
													<div class="form-group col-md-4">
														<label class="form-label" for="userMobile">Mobile</label>
														<input formControlName="userMobile" type="text"
															name="userMobile" id="userMobile" class="form-control"
															placeholder="User Mobile" readonly/>
													</div>
												</div>
											</fieldset>
											<div class="profileField">
												<fieldset class="border" style="padding: 0.7rem;">
													<legend class="w-auto">
														<h5 style="margin-top: 7px;">Personal Information</h5>
													</legend>
													<div class="row">
														<div class="form-group col-md-4">
															<label class="form-label" for="department">Title<span
																class="required-asterisk">*</span></label>
															<input formControlName="title" type="text" name="title"
																id="title" class="form-control" placeholder="Title" [ngClass]="{ 'is-invalid': submitted && !profileData.title.valid }" />
															<span *ngIf="submitted && profileData.title.invalid"
																class="invalid-form">
																<small class="form-text text-danger"
																	*ngIf="profileData.title.errors.required">This
																	field is required!</small>
															</span>
														</div>
														<div class="form-group col-md-4">
															<label class="form-label" for="department">Date Of Birth<span
																class="required-asterisk">*</span></label>
															<div class="input-group">
																<input class="form-control" placeholder="dd-mm-yyyy" name="dateOfBirth"
																	formControlName="dateOfBirth" ngbDatepicker #MinMaxDP="ngbDatepicker"
																	[minDate]="{year: minDate.year, month: minDate.month, day:minDate.day}"
																	[readonly]="true" [ngClass]="{ 'is-invalid': submitted && !profileData.dateOfBirth.valid }"/>
																<div class="input-group-append">
																	<button class="btn btn-outline-secondary feather icon-calendar form-control"
																		(click)="setStartMinDate(); MinMaxDP.toggle();" type="button"
																		rippleEffect></button>
																</div>
															</div>
															<span *ngIf="submitted && profileData.dateOfBirth.invalid" class="invalid-form">
																<small class="form-text text-danger" *ngIf="profileData.dateOfBirth.errors.required">This
																	field is required!</small>
															</span>
														</div>
														<div class="form-group col-md-4">
															<label class="form-label" for="gender">Gender</label>
															<div class="demo-inline-spacing" style="margin-top: -15px;">
																<div class="custom-control custom-radio">
																	<input type="radio" id="genderM"
																		formControlName="gender" name="gender"
																		class="custom-control-input" value="M" />
																	<label class="custom-control-label"
																		for="genderM">Male</label>
																</div>
																<div class="custom-control custom-radio">
																	<input type="radio" id="genderF"
																		formControlName="gender" name="gender"
																		class="custom-control-input" value="F" />
																	<label class="custom-control-label"
																		for="genderF">Female</label>
																</div>
																<div class="custom-control custom-radio">
																	<input type="radio" id="genderO"
																		formControlName="gender" name="gender"
																		class="custom-control-input" value="O" />
																	<label class="custom-control-label"
																		for="genderO">Other</label>
																</div>
															</div>
														</div>
													</div>
													<div class="row">
														<div class="form-group col-md-4">
															<label class="form-label"
																for="department">Department<span
																class="required-asterisk">*</span></label>
															<input formControlName="department" type="text"
																name="department" id="department" class="form-control"
																placeholder="Department"  [ngClass]="{ 'is-invalid': submitted && !profileData.department.valid }"/>
															<span *ngIf="submitted && profileData.department.invalid" class="invalid-form">
																<small class="form-text text-danger" *ngIf="profileData.department.errors.required">This
																	field is required!</small>
															</span>
														</div>
														<div class="form-group col-md-4">
															<label class="form-label"
																for="designation">Designation<span
																class="required-asterisk">*</span></label>
															<input formControlName="designation" type="text"
																name="designation" id="designation" class="form-control"
																placeholder="Designation" [ngClass]="{ 'is-invalid': submitted && !profileData.designation.valid }"/>
															<span *ngIf="submitted && profileData.designation.invalid" class="invalid-form">
																<small class="form-text text-danger" *ngIf="profileData.designation.errors.required">This
																	field is required!</small>
															</span>	
														</div>
														<div class="form-group col-md-4">
															<label class="form-label" for="identityProof">Identity Proof
															</label>
															<ng-select [items]="identityProofs" bindLabel="identityProofName" bindValue="identityProofID" formControlName="identityProof" placeholder="Identity Proof">
															</ng-select>
														</div>
													</div>
													<div class="row">
														<div class="form-group col-md-4">
															<label class="form-label" for="institute">Institute<span
																class="required-asterisk">*</span></label>
															<input formControlName="institute" type="text"
																name="institute" id="institute" class="form-control"
																placeholder="Institute Name" [ngClass]="{ 'is-invalid': submitted && !profileData.institute.valid }"/>
															<span *ngIf="submitted && profileData.institute.invalid" class="invalid-form">
																<small class="form-text text-danger" *ngIf="profileData.institute.errors.required">This
																	field is required!</small>
															</span>
														</div>
														<div class="form-group col-md-4">
															<label class="form-label" for="instituteAddress">Institute
																Address<span class="required-asterisk">*</span></label>
															<textarea formControlName="instituteAddress" type="text"
																name="instituteAddress" id="instituteAddress"
																class="form-control" [ngClass]="{ 'is-invalid': submitted && !profileData.instituteAddress.valid }"
																placeholder="Institute Address"></textarea>
															<span *ngIf="submitted && profileData.instituteAddress.invalid" class="invalid-form">
																<small class="form-text text-danger" *ngIf="profileData.instituteAddress.errors.required">This
																	field is required!</small>
															</span>
														</div>
														<div class="form-group col-md-4" *ngIf="isExpert">
															<label class="form-label" for="expertCategory">Expert Category</label>
															<input formControlName="expertCategory" type="text"
																name="expertCategory" id="expertCategory" class="form-control"
																placeholder="expertCategory Name" readonly/>
														</div>
													</div>
												</fieldset>
												<fieldset class="border" style="padding: 0.7rem;">
													<legend class="w-auto">
														<h5 style="margin-top: 7px;">Contact Details</h5>
													</legend>
													<div class="row">
														<div class="form-group col-md-4">
															<label class="form-label" for="country">Country</label>
															<ng-select [items]="countryArray" bindLabel="countryName"
																bindValue="countryID" formControlName="country"
																placeholder="Country" [ngClass]="{ 'is-invalid': submitted && !profileData.country.valid }"
																(change)="getstateDetails($event)">
															</ng-select>
														</div>
														<div class="form-group col-md-4">
															<label class="form-label" for="state">State</label>
															<ng-select [items]="stateArray" bindLabel="stateName"
																bindValue="stateID" formControlName="state"
																placeholder="State"
																(change)="getCityDistrictDetails($event)" [ngClass]="{ 'is-invalid': submitted && !profileData.state.valid }">
															</ng-select>
														</div>
														<div class="form-group col-md-4">
															<label class="form-label" for="city">City</label>
															<ng-select [items]="cityArray" bindLabel="cityName"
																bindValue="cityID" formControlName="city"
																placeholder="City" [ngClass]="{ 'is-invalid': submitted && !profileData.city.valid }">
															</ng-select>
														</div>
													</div>
													<div class="row">
														<div class="form-group col-md-4">
															<label class="form-label" for="address">Address1</label>
															<input formControlName="address1" type="text"
																name="address1" id="address1" class="form-control"
																placeholder="address1"/>
															
														</div>
														<div class="form-group col-md-4">
															<label class="form-label" for="address2">Address2</label>
															<input formControlName="address2" type="text"
																name="address1" id="address2" class="form-control" placeholder="address2"/>
															
														</div>
														<div class="form-group col-md-4">
															<label class="form-label" for="pincode">Pin</label>
															<input formControlName="pincode" type="text" name="pincode"
																id="pincode" class="form-control" placeholder="Pin" />
														</div>
													</div>
													<div class="row">
														<div class="form-group col-md-4">
															<label class="form-label" for="landline">Landline
															</label>
															<input formControlName="landline" type="text"
																name="landline" id="landline" class="form-control"
																placeholder="Landline" [mask]="'^([1-9]\\d*|0)$'"
																maxlength="12" />
														</div>
													</div>
												</fieldset>
												<div class="row pull-right">
													<div class="col-12">
														<button type="submit" class="btn btn-primary mr-1 mt-1" (click)="saveProfileData()"
															rippleEffect>Submit</button>
													</div>
												</div>
											</div>
										</form>
									<!-- </div> -->
								<!-- </div> -->
							</ng-template>
						</li>
						<li class="nav-item" ngbNavItem>
							<a ngbNavLink class="nav-link d-flex py-75" id="account-pill-password" data-toggle="pill"
								href="#account-vertical-password" aria-expanded="false">
								<i data-feather="lock" class="font-medium-3 mr-1"></i>
								<span class="font-weight-bold">Change Password</span>
							</a>
							<ng-template ngbNavContent>
								<div class="card">
									<div class="card-body">
										<!-- form -->
										<form [formGroup]="changePasswordform" class="validate-form">
											<div class="row">
												<div class="col-12 col-sm-6">
													<div class="form-group" >
														<label for="account-old-password">Old Password</label>
														<div class="input-group form-password-toggle input-group-merge">
															<input [type]="passwordTextTypeOld ? 'text' : 'password'"
																class="form-control" id="account-old-password"
																formControlName="password" placeholder="Old Password" [ngClass]="{ 'is-invalid': submitted && !updatePassword.password.valid }"/>
															<div class="input-group-append">
																<span class="input-group-text cursor-pointer">
																	<i class="feather font-small-4" [ngClass]="{'icon-eye-off': passwordTextTypeOld,'icon-eye': !passwordTextTypeOld,'is-invalid': submitted && !updatePassword.password.valid }" (click)="togglePasswordTextTypeOld()">
																	</i></span>
															</div>
														</div>
														<span *ngIf="submitted && updatePassword.password.invalid" class="invalid-form">
															<small class="form-text text-danger" *ngIf="updatePassword.password.errors.required">This
																field is required!</small>
														</span>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-12 col-sm-6">
													<div class="form-group">
														<label for="account-new-password">New Password</label>
														<div class="input-group form-password-toggle input-group-merge">
															<input [type]="passwordTextTypeNew ? 'text' : 'password'"
																id="account-new-password" formControlName="newPassword"
																class="form-control" placeholder="New Password" 
																[ngClass]="{ 'is-invalid': submitted && !updatePassword.newPassword.valid }"
																minlength="6"
						                                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
																/>
															<div class="input-group-append">
																<span class="input-group-text cursor-pointer"><i
																		class="feather font-small-4" [ngClass]="{
                                      'icon-eye-off': passwordTextTypeNew,
                                      'icon-eye': !passwordTextTypeNew
                                    }" (click)="togglePasswordTextTypeNew()"></i></span>
															</div>
														</div>
						
														<!-- <sup>The password must contain minimum 8 characters with at least one number, one uppercase and one lowercase letter.</sup> -->
														<span *ngIf="submitted && updatePassword.newPassword.invalid" class="invalid-form">
															<small class="form-text text-danger" *ngIf="updatePassword.newPassword.errors.required">This
																field is required!</small>
															
																<small *ngIf="updatePassword.newPassword.errors.pattern">The password must contain minimum 8 characters with at least one number, one uppercase and one lowercase letter.</small>
														</span>
													</div>
												</div>
												<div class="col-12 col-sm-6">
													<div class="form-group">
														<label for="account-retype-new-password">Retype New
															Password</label>
														<div class="input-group form-password-toggle input-group-merge">
															<input [type]="passwordTextTypeRetype ? 'text' : 'password'"
																class="form-control" id="account-retype-new-password"
																formControlName="confirmNewPassword" pattern="{{ updatePassword.newPassword.value }}"
																placeholder="New Password" [ngClass]="{ 'is-invalid': submitted && !updatePassword.confirmNewPassword.valid }"/>
															<div class="input-group-append">
																<span class="input-group-text cursor-pointer"><i
																		class="feather font-small-4" [ngClass]="{
                                      'icon-eye-off': passwordTextTypeRetype,
                                      'icon-eye': !passwordTextTypeRetype
                                    }" (click)="togglePasswordTextTypeRetype()"></i></span>
															</div>
														</div>
														<span *ngIf="submitted && updatePassword.confirmNewPassword.invalid" class="invalid-form">
															<small class="form-text text-danger" *ngIf="updatePassword.confirmNewPassword.errors.required">This
																field is required!</small>
															<small class="form-text text-danger" *ngIf="updatePassword.confirmNewPassword.errors.pattern">Password & Confirm Password does not match.</small>
														</span>
													</div>
												</div>
												<div class="col-12">
													<button type="submit" class="btn btn-primary mr-1 mt-1"
														rippleEffect (click)="changePassword()">Save changes</button>
													<button type="reset" class="btn btn-outline-secondary mt-1"
														rippleEffect>Cancel</button>
												</div>
											</div>
										</form>
										<!--/ form -->
									</div>
								</div>
							</ng-template>
						</li>
					</ul>
				</div>
				<div [ngbNavOutlet]="navVertical" class="col-12 col-md-9"></div>
			</div>
		</section>
		<!--/ account setting page -->
	</div>
</div>